import { UNIT, mainColor } from '../../constants/theme';

export const styles = ({

  dayLabel: {
    fontSize: UNIT * 0.8
  },
  removeIcon: {
    width: UNIT * 1.5,
    height: UNIT * 1.5,
  },
  hrStyle: {
    width: '100%',
    borderBottom: '0.1px solid #999999'
  },
  textField: {
    marginLeft: UNIT * 0.5,
    marginRight: UNIT * 0.5,
    fontSize: UNIT
  },
  errorMessage: {
    color: 'red',
    fontSize: UNIT * 0.6875
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack,
    align: 'center'
  },
  removeButton: { width: UNIT, height: UNIT },
  addIcon: { fontSize: UNIT },
  slots: {
    marginLeft: -UNIT * 18.75
  },
  choiceText: {
    alignSelf: 'center',
    fontSize: UNIT * 1.1875,
    color: `rgba(${mainColor.rgb}, 0.8)`
  },
  iconStyle: {
    width: UNIT * 1.5,
    height: UNIT * 1.5,
    align: 'center',
    margin: UNIT * 0.3125
  },
  slotStyle: {
    marginTop: UNIT * 0.375, lineHeight: `${UNIT * 1.25}px`,
    maxWidth: UNIT * 9.1875,
    marginRight: UNIT * 1.75
  },
  slotError: {
    marginLeft: -UNIT * 1.75,
    color: 'red',
    fontSize: UNIT * 0.6875
  }
});
